/* eslint-disable react-refresh/only-export-components */
import { useState, useEffect } from 'react';

export interface ToastMessage {
  id: number;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
}

const ICONS = {
  success: 'ri-checkbox-circle-line text-[#10b981]',
  error:   'ri-error-warning-line text-red-400',
  warning: 'ri-alert-line text-amber-400',
  info:    'ri-information-line text-[#38bdf8]',
};

let _toastId = 0;

// 全局派发函数，供非 React 模块（如 http.ts）调用
export function dispatchToast(type: ToastMessage['type'], message: string) {
  window.dispatchEvent(new CustomEvent('wanxiang_toast', { detail: { type, message } }));
}

export default function GlobalToast() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const { type, message } = (e as CustomEvent<{ type: ToastMessage['type']; message: string }>).detail;
      const id = ++_toastId;
      setToasts((prev) => [...prev, { id, type, message }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 3000);
    };
    window.addEventListener('wanxiang_toast', handler);
    return () => window.removeEventListener('wanxiang_toast', handler);
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="pointer-events-auto bg-gray-900 text-white px-5 py-3 rounded-2xl text-sm font-medium flex items-center gap-2 shadow-xl animate-toast-in max-w-[80vw]"
        >
          <i className={`${ICONS[toast.type]} text-lg`}></i>
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
}
